export const WAITING = 'WAITING';
export const BYPASS = 'BYPASS';
export const NO_BYPASS = 'NO_BYPASS';
